import { LANDSCAPE_VIEW_FACTS } from '@/api/rest/resources/types/fact';
import { useLandscapeViewContext } from '@/pages/shared/projects/pages/project/pages/sustainableProduction/pages/plot/LandscapeViewContextProvider';

import { useIndicatorProduct } from './useIndicatorProduct';

export const useIsLandscapeViewIndicatorProductPurchased = () => {
  const purchasedIndicatorProducts =
    useIndicatorProduct({
      purchased: true,
      visible_for_customer: true,
    }).data ?? [];

  return purchasedIndicatorProducts.some((ip) =>
    ip.indicator_names.some((name) => LANDSCAPE_VIEW_FACTS.includes(name)),
  );
};

export const useLandscapeView = () => {
  const { isLandscapeActive: isToggleButtonActive } = useLandscapeViewContext();
  const isAnyLandscapeViewProductPurchased = useIsLandscapeViewIndicatorProductPurchased();

  return {
    isActive: isToggleButtonActive && isAnyLandscapeViewProductPurchased,
  };
};
